import {produce} from 'immer';
import {Injectable} from '@angular/core';
import * as PL2 from '@common/utils/dist/models/models-pl2.js';
import {EntryUtilsPL2 as EU} from '@common/utils/dist/utils/entry-utils-pl2.js';
import {KeyUtilsPL2 as KU} from '@common/utils/dist/utils/key-utils-pl2.js';
import {UtilsPL2 as U} from '@common/utils/dist/utils/utils-pl2.js';
import {StateTransformer} from '../abstract-store';
import {EntryState} from '../entry.store';
import {ReceiveDeactivateStrategy} from '../entry-store-automaton/modification-strategy';

@Injectable({
  providedIn: 'root',
})
export class ReceiveDeactivatedEntriesTransformer implements StateTransformer<
  Array<PL2.AnyPartialEntryWithId>,
  EntryState
> {
  hasChanged = false;

  transform(
    partialChanges: Array<PL2.AnyPartialEntryWithId>,
    state: EntryState,
  ): EntryState {
    this.hasChanged = false;
    partialChanges = partialChanges ?? [];
    const changes = partialChanges.filter((change) =>
      EU.isSyncableEntry(change),
    );
    if (partialChanges.length !== changes.length) {
      console.warn(
        'Attempt to put corrupted data into the EntryState',
        partialChanges,
      );
    }

    if (U.isEmpty(changes)) {
      return state;
    }

    const strategy = new ReceiveDeactivateStrategy();
    return produce(state, (draft: EntryState) => {
      changes.forEach((c) => {
        const pK = KU.stringFromKey(c as PL2.EntryId);
        const result = strategy.modify(c, draft);
        if (result === null) {
          return;
        }
        draft[pK]._ts = U.timestamp();
        this.hasChanged = true;
      });
    });
  }
}
